import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable, catchError, distinctUntilChanged, filter, first, forkJoin, map, merge, mergeMap, of, tap, toArray } from 'rxjs';
import { IAnalyze } from 'src/app/shared/interfaces/analyze.interface';
import { IOrgan } from 'src/app/shared/interfaces/organ.interface';
import { environment } from 'src/environments/environment';
import { GlobalService, JwtService, LocalStorageService } from '../index.service';
import { Profile } from 'src/app/shared/interfaces/profile.interface';
import { ChangeStyleModalComponent } from 'src/app/shared/components/modals/change-style-modal/change-style-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalDataService } from '../global/modal-data.service';
import * as moment from 'moment';


export interface IStateUser {
  pageNumber:number,
  pageSize:number,
  lastPage:number,
  searchValue:string,
  scrollPosition:number,
  users:Profile[],
  ordering:string,
}
@Injectable({
  providedIn: 'root'
})

export class AnalyzeService {
  readonly BASE_URL = environment.BASE_API_URL;
  readonly QUIZ_BASE_URL = environment.QUIZ_API_URL;
  username:string = ''
  reportGraphExam:any=null;
  reportExamListDetail:any=null;
  reportReviewData:any=null
  commentData:any = null;
  formData:any = null;
  organListUsername:string[] = []
  reportCardSettingBar:BehaviorSubject<boolean> = new BehaviorSubject(false)
  analysisCount = 1;
  stateObj:IStateUser|null = null
  charactersClone:any = []
  charactersChanged:any = []
  analysisReportOwnerOrderStatus = false
  changeStyleReportCardSignal = signal(false)
  NoDataForProfileRequiredAndRequiredDataSignal = signal(false)
  constructor(
    private http:HttpClient,
    public jwtService:JwtService,
    private dialog:MatDialog,
    private globalService:GlobalService,
    private modalservice:ModalDataService,
    private localStorageService:LocalStorageService
  ) { }

  setAnalysisReportOwnerOrderStatus(bool:boolean){
    this.analysisReportOwnerOrderStatus = bool
  }
  getAnalysisReportOwnerOrderStatus(){
    return this.analysisReportOwnerOrderStatus
  }
  setCharactersClone(cloned:any){
    this.charactersClone = cloned
  }
  setCharactersChanged(changed:any){
    this.charactersChanged = changed
  }
  compaireCharactersCloneVsChanged(){
    let checker = false;
    this.charactersClone.forEach(
      ((item:any)=>{
        let arr = this.charactersChanged.filter((el:any)=>{
          if(el.id && el.id == item.id) return el 
          if(el.character && el.character == item.character) return el 
        })
        if(!checker){
          if(arr[0].point!=item.point){
            checker = true
          }else checker = false
        }
      })
    )
    return checker
  }
  setMoreSettingNav(status:boolean){
    this.reportCardSettingBar.next(status)
  }

  getMoreSettingNav(){
    return this.reportCardSettingBar
  }
  getAnalyzeList(username?:string): Observable<IAnalyze[]>{
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/form/own_form/?formadmin__admin_username=${username}`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getOrganList():Observable<string[]>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<string[]>(`${this.QUIZ_BASE_URL}analysis/requester_list/`).pipe(catchError(err=>{throw err}))
      })
    ) 
  }
  getOrgan(analysor_username:string){
    return this.http.get(`${this.BASE_URL}organ/${analysor_username}`)
  }
  getOrganListByAnalyzeRequesterUsername(page:number=1) : Observable<IOrgan[]>{
    return this.getOrganList().pipe(
      map((val:any)=>{
        if(val.results!=0) val.results.map((v:any)=>this.organListUsername.push(v.requester_username))
        return val
      }),
      mergeMap((data:any)=>{
        if(this.organListUsername.length!=0){
          return this.getEntitys(this.organListUsername).pipe(
            map((requestData:any)=>{
              requestData.results.forEach(
                (user:any)=>{
                  let searchedUser = data.results.find((x:any)=>x.requester_username==user.username)
                  if(searchedUser){
                    user.analysis_count = searchedUser.analysis_count
                    user.submiter_counter = searchedUser.submiter_counter
                  }
                }
              )
              return requestData
            })
          )
        }else return of([])
      })
    )
  }
  getEntityData(username:string): Observable<IOrgan>{
    return this.http.get<any>(`${this.BASE_URL}organ/?username=${username}`).pipe(
      catchError((err=>{throw err})),
      map(i=>i.results)
    )
  }
  getUsers(usernameList:string[]|[], pageSize:number=5):Observable<Profile[]>{
    return this.http.get<Profile[]>(`${this.BASE_URL}auth/users/?username__in=${usernameList.join(',')}&page_size=${pageSize}`).pipe(
      catchError((err=>{throw err})),
    )
  }
  getPlanListByOrgan(organUsername:string,page:number=1): Observable<IAnalyze[]>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/?form__requester_username=${organUsername}&page=${page}`).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getOrderPlanList(page:number=1){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/form/own_form/?page=${page}`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getAnalysisedAdminList(form_id:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/analyser_list`,{headers}).pipe(
          mergeMap((data:string[])=>{
            return this.http.get<IOrgan[]>(`${this.BASE_URL}auth/users/?username__in=${data.join(',')}&page_size=${data.length}`).pipe(
              map((i:any)=>i.results),
              catchError(err=>{throw err})
            )
          }),
          catchError(err=>{throw err})
        )
      })
    )
  }
  getSinglePlanById(form_id:string):Observable<IAnalyze>{
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getSingleAnalysedPlanById(analysis_id:string):Observable<IAnalyze>{
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/${analysis_id}/`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getAnalysedUsersList(page_size:number=5,page_number:number=1,ordering:string='-updated_at',searched:string='',logginedAs:string='requester'){
    let situationList:any[] = []
    let analyserList:any[] = []
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap(()=>{
        return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/form/submit?status!=OPEN&logined_as=${logginedAs}&ordering=${ordering}&page_size=${page_size}&page=${page_number}&search=${searched}`,{headers}).pipe(
          map((data:any)=>{
            this.analysisCount = data.count
            let usernameList:string[] = []
            Object.entries(data.results).forEach((item:any) => {
              usernameList.push(item[0])
              situationList.push({user:item[0],results:[...item[1]]})
            });
            data.results = usernameList
            return data
          }),
          mergeMap((data:any)=>{
            return this.getEntitys(data.results).pipe(
              map((List:any)=>{
                situationList.forEach((item:any)=>{
                  let user:any = List.results.filter((i:any)=>i.username === item.user)[0]
                  item.user = user
                  item.openState = false
                  item.id = Math.floor(Math.random()*10000)
                  if(logginedAs=='requester'){
                    item.results.forEach((element:any) => {
                      analyserList.push(...element.analysis.map((ix:any)=>{
                        if(ix.analyser_username){ return ix.analyser_username }
                      }))
                    });
                  }
                })
                return situationList
              }),
              mergeMap((resolve:any)=>{
                if(logginedAs=='requester'){
                  return this.getEntitys(analyserList).pipe(
                    map((item:any)=>{
                      let ordersGharList = item.results
                      resolve.forEach((ie:any)=>{
                        ie.results.forEach((ia:any)=>{
                          ia.analysis.forEach((im:any)=>{
                            if(ia.analysis.length!=0){
                              im.data = {...ordersGharList.filter((find:any)=>{return find.username == im.analyser_username})[0]}
                            }
                          })
                        })
                      })
                      return resolve
                    })
                  )
                }else{
                  // resolve.forEach((item:any)=>{
                  //   item.results.forEach((ele:any)=>{
                  //     ele.analysis = []
                  //   })
                  // })
                  return of(resolve)
                }
              })
            )
          }),
          catchError(err=>{throw err})
        )
      })
    )
  }
  getAnalysedUsersListByPlanId(form_id:string,page_size:number=5,page_number:number=1,ordering:string='-updated_at',searched:string='',logginedAs:string='requester'){
    let situationList:any[] = []
    let analyserList:any[] = []
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        let url = `analysis/form/submit/?status!=OPEN&logined_as=${logginedAs}&form_id=${form_id}&page_size=${page_size==0 ? 5 : page_size}&page=${page_number==0 ? 1 : page_number}&ordering=${ordering}&search=${searched}`;
        return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}${url}`).pipe(
          map((data:any)=>{
            this.analysisCount = data.count
            let usernameList:string[] = []
            Object.entries(data.results).forEach((item:any) => {
              let formList = [...item[1].filter(((i:any)=> i.analysis.id == form_id || (i.analysis.length!=0 && i.analysis[0].id == form_id) || i.form.id == form_id))]
              if(formList.length!=0) {
                usernameList.push(item[0])
                situationList.push({user:item[0],results:[...formList]})
              }
            });
            data.results = usernameList
            return data
          }),
          mergeMap((data:any)=>{
            if(!data.results.length) return of([]);
            return this.getEntitys(data.results).pipe(
              map((List:any)=>{
                situationList.forEach((item:any)=>{
                  let user:any = List.results.filter((i:any)=>i.username === item.user)[0]
                  item.user = user
                  item.openState = false
                  item.id = Math.floor(Math.random()*10000)
                  if(logginedAs=='requester'){
                    item.results.forEach((element:any) => {
                      analyserList.push(...element.analysis.map((ix:any)=>{
                        if(ix.analyser_username && !analyserList.find((item:any)=>item != ix.analysed_username)){ return ix.analyser_username }
                      }))
                    });
                  }
                })
                return situationList
              }),
              mergeMap((resolve:any)=>{
                if(logginedAs=='requester'){
                  return this.getEntitys(analyserList).pipe(
                    map((item:any)=>{
                      let ordersGharList = item.results
                      resolve.forEach((ie:any)=>{
                        ie.results.forEach((ia:any)=>{
                          ia.analysis.forEach((im:any)=>{
                            if(ia.analysis.length!=0){
                              im.data = {...ordersGharList.filter((find:any)=>{return find.username == im.analyser_username})[0]}
                            }
                          })
                        })
                      })
                      return resolve
                    })
                  )
                }else {
                  // resolve.forEach((item:any)=>{
                  //   item.results.forEach((ele:any)=>{
                  //     ele.analysis = []
                  //   })
                  // })
                  return of(resolve)
                }
              }),
            )
          }),
          catchError(err=>{throw err})
        )
      })
    )
  }
  getUnverifiedUsersListByPlanId(form_id: string) {
    let url = `analysis/form/submit/total_records/?form_id=${form_id}&status!=OPEN&is_verified_by_requester=false`;
    return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}${url}`).pipe(
      mergeMap((response: any) => {
        if (!response.length) return of([]);
        let usernameList = response.map((item: any) => item.analysed_username);
        return this.getEntitys(usernameList).pipe(
          map((usersList: any) => {
            return response.map((item: any) => {
              const matchedUser = usersList.results.find(
                  (element: any) => element.username === item.analysed_username
              );
              if (matchedUser) {
                  item.user = matchedUser;
              }
              return item;
            });
          }),
          catchError(err=>{throw err})
        );
      }),
      catchError(err=>{throw err})
    );
  }
  getSingleFormSubmitDetail(formSubmitId:any,logginedAs:any){
    return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/submit/${formSubmitId}/?logined_as=${logginedAs}`).pipe(
      catchError(err=>{throw err})
    )
  }
  getProfileRequiredDataObs(form_id:string,userId:string,loginedAs:'requester'|'analyser'):Observable<any>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/profile_required_data/${userId}/status/?logined_as=${loginedAs}`).pipe(
          map((item:any)=>{
            return {type:'profileRequired',data:{...item}}
          }),
          catchError(err=>{throw err})
        )
      })
    )
  }
  getRequiredDataObs(form_id:string,userId:string,loginedAs:'requester'|'analyser'):Observable<any>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/required_data/${userId}/status/?logined_as=${loginedAs}&ordering=created_at`).pipe(
          map((item:any)=>{
            return {type:'requiredData',data:{...item}}
          }),
          catchError(err=>{throw err})
        )
      })
    )
  }
  getRequiredQuizDataObs(form_id:string,userId:string,loginedAs:'requester'|'analyser'):Observable<any>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/analysis/required_quizes/${userId}/status/?logined_as=${loginedAs}`).pipe(
          map((item:any)=>{
            return {type:'requiredQuiz',data:{...item}}
          }),
          catchError(err=>{throw err})
        )
      })
    )
  }
  mergeAllRequiredsObs(form_id:string, userId:string,loginedAs:'requester'|'analyser'){
    return merge(
      this.getProfileRequiredDataObs(form_id,userId,loginedAs).pipe(first()),
      this.getRequiredDataObs(form_id,userId,loginedAs).pipe(first()),
      this.getRequiredQuizDataObs(form_id,userId,loginedAs).pipe(first()),
    )
  }
  getQuizGraphList(form_id:string,userId:string,logginedAs:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/analysis/required_quizes/${userId}/graph/?logined_as=${logginedAs}`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getAllCharecters(){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/character`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getAnalysisListInReportCard(formId:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/?is_secret=false&form__id=${formId}`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getCharectersListByAnalysisId(id:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/character/?analysis__id=${id}`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  setCharetersPoints(points:any,analysisId:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.post<any>(`${this.QUIZ_BASE_URL}analysis/${analysisId}/character_value/`,points,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getAnalyzer(formId:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/${formId}/`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getCharectersPoints(id:string){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/${id}/character_value/`).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getFullDetailOfAnalysis(formSubmittedId:string,formId:string){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_BASE_URL}analysis/full_detail/${formSubmittedId}/?is_secret=false&form__id=${formId}`).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getSingleDetailOfAnalysis(formSubmittedId:string,analysisId:string){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/${analysisId}/full_detail/${formSubmittedId}/`).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getForm(formId:string){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get(`${this.QUIZ_BASE_URL}analysis/form/${formId}/`).pipe(
          mergeMap((response:any)=>{
            return this.getEntitys([response.requester_username]).pipe((
              map((data:any)=>{
                return {...response,entity:data.results[0]}
              })
            ))
          })
        )
      }),
      first()
    )
    
  }
  getAnalysedReportFormSubmitForUser(formId:string,formSubmittedId:string){
    let obs$ = forkJoin({
      form: this.getForm(formId),
      report: this.getSingleReportUser(formSubmittedId)
    }).pipe()
    return obs$
    
  }
  getSingleReportUser(formSubmittedId:string){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/analysed_report/${formSubmittedId}/`).pipe(
          catchError(err=>{throw err})
        )
      }),
      first()
    )
  }
  getEntitys(usernameList:string[]){
    return this.http.get<any>(`${this.BASE_URL}entity/?username__in=${usernameList?.join(',')}&page_size=${usernameList.length}`)
  }
  getAnalysisComment(analysis_id:string,form_submitted:string){
    return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/${analysis_id}/comment/${form_submitted}/`).pipe(
      catchError(err=>{throw err})
    )
  }
  sendAnalysisComment(analysis_id:string,data:any){
    return this.http.post<any>(`${this.QUIZ_BASE_URL}analysis/${analysis_id}/comment/`,data).pipe(
      catchError(err=>{throw err})
    )
  }
  setHeaders(account:any){
    let headers = new HttpHeaders()
    if(account.last_logined_role=='ORGAN'){
      headers = headers.append('Organ-Username',account.username)
    }
    return headers
  }
  isPrivate(notif:any){
    return notif.status=='PRIVATE'
  }
  isActive(notif:any){
      return notif.status=='ACTIVE'
  }
  isInActive(notif:any){
      return notif.status=='INACTIVE'
  }
  isStart(notif:any){
      return notif.is_started
  }
  isExpired(notif:any){
      return notif.is_expire
  }
  setInActiveClass(notif:any){
    if(notif?.status=='INACTIVE'){return true}
    else{
      if(notif?.is_started==false){return true}
      else{
        if(notif.is_expire) return true
        else return false
      }
    }
  }
  setActiveClass(notif:any){
    if((notif.is_started==true || notif.is_started==null) && notif.status=='ACTIVE' && !notif.is_expire){return true}
    else{return false}
  }
  status(logginAs:string,data:any):any{
    if(logginAs=='kar'){
      if(!data.analysis[0].is_completed){
        if(data.form.is_open_to_analyser && data.status!='ANSWERED'){
          return {status:'ANALYSING', name:'در انتظار ارزیابی', class:'blue-style'}
        }else{
          return {status:'CLOSED', name:'بسته شده', class:'red-style'}
        }
      }else{
        return {status:'COMPLETED', name:'ارزیابی شده', class:'green-style'}
      }
    }else{
      if(data.status=='ANSWERED'){
        return {status:'ANSWERED', name:'پاسخ داده شده', class:'green-style'}
      }else{
        if(data.analysis.length==0){
          return {status:'DECIDING', name:'در انتظار جمع‌بندی', class:'blue-style'}
        }else{
          if(this.checkValues(data)){
            return {status:'DECIDING', name:'در انتظار جمع‌بندی', class:'blue-style'}
          }else{
            return {status:'ANALYSING', name:'فرآیند ارزیابی', class:'yellow-style'}
          }
        }
      } 
    }
  }
  checkValues(data:any) {
    if(data.analysis.length==0) return false
    for (let obj of data.analysis) {
      if (!obj.is_completed) {  // If any value is false
          return false;
      }
    }
    return true;  // All values are true
  }
  openChangeStyleModal(){
    // const dialogRef = this.dialog.open(ChangeStyleModalComponent, {
    //   id: 'change-style-modal' ,
    //   disableClose : true ,
    //   data:{
    //     parentId: '',
    //   }
    // });
    // dialogRef.componentInstance.changeStyleEmitter.subscribe(
    //   ((stauts:any)=>{
    //     if(stauts){
    //       if(dialogRef.componentInstance.change_style_type == 'row'){
    //         this.changeStyleReportCardSignal.set(false)
    //         this.globalService.scrollToView('review')
    //         console.log(dialogRef.componentInstance.change_style_type)
    //       }
    //       this.closeChangeStyleModal()
    //       this.setStorageStatus(dialogRef.componentInstance.changeModalQuestionStatus,dialogRef.componentInstance.change_style_type)
    //     }
    //   })
    // );
  }
  closeChangeStyleModal(){
    this.modalservice.is_sure = false
    this.dialog.getDialogById('change-style-modal')?.close()
  }
  checkOpenLocalStorageForChangeStyle(){
    let change_evaluation_modal :{check_modal_status:string,time:string} = this.localStorageService.getData('change_evaluation_modal')
    if(change_evaluation_modal){
      if(change_evaluation_modal.check_modal_status){
        return false
      }
      else if(!this.check24HourDifference(change_evaluation_modal.time)){
        return false
      }
      else
        return true
      // change_evaluation_modal.date = 
    }
    else{
      return true
    }
  }
  check24HourDifference(lastTime: string | Date): boolean {
    const now = moment();
    const last = moment(lastTime);
    return now.diff(last, 'hours') >= 24;
  }
  setStorageStatus(status:boolean,type:'row'|'col'){
    const now = moment();
    let obj = {
      check_modal_status:status,
      time:now,
      type:type
    }
    console.log(obj)
    this.localStorageService.setData('change_evaluation_modal',obj)
  }
}